import axios from 'axios'

const api = axios.create({
 baseURL:'https://api.igrys.com/apilojas'
})

export default api;